import { Router } from '@angular/router';
import { Component, Inject, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatCheckboxChange, MatDialogRef, MatSelectChange, MatSnackBar } from '@angular/material';
import { MatTableDataSource, MatPaginator, MatSort, MatIconRegistry } from '@angular/material';
import { Business } from '../models/business.model';
import { BusinessAdminNote } from '../models/business-admin-notes.model';
import { BusinessAdminNotesService } from '../services/businessAdminNotes.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { TagService } from '../../shared/services/tag.service';
import { hasTag } from '../../util/tag-utils';
import { AirportService } from '../../airport/airport.service';
import { NgForm } from '@angular/forms';
import { Tag } from '../../shared/models/tag.model';

@Component({
  selector: 'app-admin-business',
  templateUrl: './admin-business.component.html',
  styleUrls: ['./admin-business.component.scss'],

})
export class AdminBusinessComponent implements OnInit {

  @Input() notesArray: Array<BusinessAdminNote>;

  business: Business;
  hasTag = hasTag;
  model: any = {};
  adminDeleteConfirmationArray: Array<boolean> = [];
  dataSource: MatTableDataSource<any>;
  businessNotesToDelete: Array<any> = [];
  FTMagTag: Tag;
  getsFTMagazine: boolean;
  datesArray: Array<BusinessAdminNote>;
  lastUpdateDate: string = null;
  lastUpdateBy = '';
  lastVerifiedDate: string = null;
  lastVerifiedBy = '';
  lastFeeUpdateDate: string = null;
  lastFeeUpdateBy = '';
  FlyingClubTag: Tag;
  isFlyingClub: boolean;
  FboTag: Tag;
  isFbo: boolean;
  HideBusinessTag: Tag;
  OffersTransparentPricingTag: Tag;
  offersTransparentPricing: boolean;
  AftaSchoolTag: Tag;
  isAftaSchool: boolean;
  isFlightDeckAdmin = false;
  isRegionalManager = false;
  isFlightSchool = false;
  selectedRegionalBadgeId: any;
  selectedDateRange: string;
  NationalWinnerTag: Tag;
  DistinguishedSchoolTag: Tag;
  DisplayCustomerFeedbackReportTag: Tag;
  DisplayPriorYearTags: Tag;
  allTags: Tag[];
  activeFTEAwardTags: Tag[];
  activeRegionalTags: Tag[];
  availableDateRanges: string[] = [];
  NotApprovedTag: Tag;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public dialogRef: MatDialogRef<AdminBusinessComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private _businessService: BusinessManagerService,
              private _adminNotesService: BusinessAdminNotesService,
              private _tagService: TagService,
              private _airportService: AirportService,
              private router: Router,
              public _snackBar: MatSnackBar) {
    this.business = data.business;
    for (let i = 0; i < this.business.admins.length; i++) {
      this.adminDeleteConfirmationArray.push(false);
    }
  }

  async ngOnInit() {
    this.isRegionalManager = await this._businessService.isRegionalManager()
      && !await this._businessService.userOwnsBusiness(this.business.id);
    this.isFlightDeckAdmin = await this._businessService.isFlightDeckAdmin();
    this.isFlightSchool = (!this.business.tags.some(t => t.tagName.startsWith('Flight Training::Private'))
      && this.business.tags.some(t => t.tagName.startsWith('Flight Training')));
    if (!this.isRegionalManager && !this.notesArray) {
      this.notesArray = await this._adminNotesService.getBusinessAdminNotes(this.business.id);
    }
    if (!this.datesArray && this.isFlightDeckAdmin) {
      this.datesArray = await this._adminNotesService.getBusinessAdminDates(this.business.id);
      for (let i = 0; i < this.datesArray.length; i++) {
        if (this.datesArray[i].note.startsWith('__LastUpdate')) {
          this.lastUpdateDate = this.datesArray[i].updateDate.toLocaleString('en-US');
          const lastUpdateName = this.datesArray[i].note.match(/__LastUpdate -  (.*)/);
          if (lastUpdateName.length > 1) {
            this.lastUpdateBy = this.datesArray[i].updateBy + ' (' + lastUpdateName[1] + ')';
          } else {
            this.lastUpdateBy = this.datesArray[i].updateBy;
          }
        }
        if (this.datesArray[i].note.startsWith('__LastVerified')) {
          this.lastVerifiedDate = this.datesArray[i].updateDate.toLocaleString('en-US');
          const lastVerifiedName = this.datesArray[i].note.match(/__LastVerified - (.*)/);
          if (lastVerifiedName.length > 1) {
            this.lastVerifiedBy = this.datesArray[i].updateBy + ' (' + lastVerifiedName[1] + ')';
          } else {
            this.lastVerifiedBy = this.datesArray[i].updateBy;
          }
        }
        if (this.datesArray[i].note.startsWith('__LastFees')) {
          this.lastFeeUpdateDate = this.datesArray[i].updateDate.toLocaleString('en-US');
          const lastFeeUpdateName = this.datesArray[i].note.match(/__LastFees -  (.*)/);
          if (lastFeeUpdateName.length > 1) {
            this.lastFeeUpdateBy = this.datesArray[i].updateBy + ' (' + lastFeeUpdateName[1] + ')';
          } else {
            this.lastFeeUpdateBy = this.datesArray[i].updateBy;
          }
        }
      }
    }
    this.setNotesDataSource();
    this.allTags = await this._tagService.getAllTags();
    this.FTMagTag = await this._tagService.findTagByName(this.allTags, 'Magazine::Bulk Distribution');
    this.getsFTMagazine = hasTag(this.business.tags, 'Magazine::Bulk Distribution');
    this.FlyingClubTag = await this._tagService.findTagByName(this.allTags, 'Flying Club');
    this.isFlyingClub = hasTag(this.business.tags, 'Flying Club');
    this.FboTag = await this._tagService.findTagByName(this.allTags, 'Admin::BusinessIsFbo');
    this.isFbo = hasTag(this.business.tags, 'Admin::BusinessIsFbo');
    this.HideBusinessTag = await this._tagService.findTagByName(this.allTags, 'Admin::HideBusiness');
    this.OffersTransparentPricingTag = await this._tagService.findTagByName(this.allTags, 'Admin::OffersTransparentPricing');
    this.offersTransparentPricing = hasTag(this.business.tags, 'Admin::OffersTransparentPricing');
    this.AftaSchoolTag = await this._tagService.findTagByName(this.allTags, 'Admin::AftaSchool');
    this.isAftaSchool = hasTag(this.business.tags, 'Admin::AftaSchool');
    this.NotApprovedTag = await this._tagService.findTagByName(this.allTags, 'Admin::BusinessNotApproved');

    this.availableDateRanges = this.getAwardTagDateRanges();
    this.DisplayCustomerFeedbackReportTag = await this._tagService.findTagByName
      (this.allTags, 'Admin::Flight Training::Display Customer Feedback Report');
    this.DisplayPriorYearTags = await this._tagService.findTagByName
      (this.allTags, 'Admin::Flight Training::Display Prior Year Badges');
  }

  async onAddNote(noteForm: NgForm) {
    try {
      const addedNote = await this._adminNotesService.createBusinessAdminNote(this.business.id, noteForm.value.note);
      if (addedNote) {
        noteForm.controls['note'].setValue('');
        noteForm.form.markAsPristine();
        noteForm.form.markAsUntouched();
        this.notesArray = await this._adminNotesService.getBusinessAdminNotes(this.business.id);
        this.setNotesDataSource();
      } else {
        this._snackBar.open('Add Business Note Failed: ' + addedNote, 'Close', {
          duration: 5000
        });
      }
    } catch (e) {
      const error = e as Error;
      this._snackBar.open('Add Business Note Failed: ' + error.message, 'Close', {
        duration: 5000
      });
    }
  }

  async onSaveNote(modifiedNote: any) {
    try {
      const updatedNote = await this._adminNotesService.updateBusinessAdminNote(
        this.business.id, modifiedNote.businessAdminNotesId, modifiedNote.note);
      if (updatedNote) {
        this.notesArray = await this._adminNotesService.getBusinessAdminNotes(this.business.id);
        this.setNotesDataSource();
      } else {
        this._snackBar.open('Updating Business Note Failed: ' + updatedNote, 'Close', {
          duration: 5000
        });
      }
    } catch (e) {
      const error = e as Error;
      this._snackBar.open('Updating Business Note Failed: ' + error.message, 'Close', {
        duration: 5000
      });
    }
  }

  async onDeleteNote(noteToDelete: any) {
    this.businessNotesToDelete.push(noteToDelete);
  }

  async deleteNote(confirmation: boolean, note: any) {
    if (confirmation) {
      const deletedNote = await this._adminNotesService.deleteBusinessAdminNote(this.business.id, note.businessAdminNotesId);

      if (deletedNote) {
        this.notesArray = await this._adminNotesService.getBusinessAdminNotes(this.business.id);
        this.setNotesDataSource();
      }
    }
    const index = this.businessNotesToDelete.indexOf(note, 0);
    this.businessNotesToDelete.splice(index, 1);
  }

  shouldDisplayDeleteButtons(notesForDeletion: any[], note: any): boolean {
    return notesForDeletion && notesForDeletion.length > 0 &&
      notesForDeletion.findIndex(n => n.businessAdminNotesId === note.businessAdminNotesId) !== -1;
  }

  onKeyUp() {
    this.model.recid = this.model.recid.replace(/\D/g, '');
  }

  setNotesDataSource() {
    this.dataSource = new MatTableDataSource(this.notesArray);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  isChecked(tagId: number): boolean {
    const TAGS = this.business.tags;
    for (const tag of TAGS) {
      if (tag.tagId === tagId) {
        return true;
      }
    }
    return false;
  }

  async checkBoxChanged(event: MatCheckboxChange) {
    const ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
    const TAG_ID = +event.source.id;
    const BUSINESS_ID = this.business.id;
    try {
      if (event.source.checked) {
        await this._tagService.postTag(TAG_ID, BUSINESS_ID);
      } else {
        await this._tagService.deleteTag(TAG_ID, BUSINESS_ID);
      }
      if (!this.isRegionalManager) {
        const newBusiness = await this._businessService.updateBusiness(this.business);
        Object.assign(this.business, newBusiness);
      }
    } catch (e) {
      this._snackBar.open(ERROR_MSG, 'Error', {
        duration: 6000
      });
      throw e;
    }
  }

  async onChangeFlyingClubType(clubType: string) {
    const tagList = this.allTags,
      newTag = this._tagService.findTagByName(tagList, clubType),
      networkClub = this._tagService.findTagByName(tagList, 'Flying Club::AOPA::AOPA Network'),
      proposedClub = this._tagService.findTagByName(tagList, 'Flying Club::AOPA::Proposed Club');

    if (hasTag(this.business.tags, networkClub.tagName)) {
      await this._tagService.deleteTag(networkClub.tagId, this.business.id);
    }
    if (hasTag(this.business.tags, proposedClub.tagName)) {
      await this._tagService.deleteTag(proposedClub.tagId, this.business.id);
    }
    if (clubType !== '') {
      await this._tagService.postTag(newTag.tagId, this.business.id);
    }
    this.business = await this._airportService.getBusiness(this.business.id.toString());
  }


  async onAddAdmin(addForm: NgForm) {
    const added = await this._businessService.addBusinessAdmin(this.business, this.model.recid);
    if (added && added === 'SUCCESS') {
      this.model.recid = '';
      addForm.form.markAsPristine();
      addForm.form.markAsUntouched();
      this.business = await this._airportService.getBusiness(this.business.id.toString());
    } else {
      this._snackBar.open('Add Admin Failed: ' + added, 'Close', {
        duration: 5000
      });
    }
  }

  onDeleteAdmin(index: number) {
    if (this.adminDeleteConfirmationArray[index]) {
      this.adminDeleteConfirmationArray[index] = false;
      return;
    }
    this.adminDeleteConfirmationArray[index] = true;
  }

  async onDeleteConfirm(recid: number, index: number) {
    const deleted = await this._businessService.deleteBusinessAdmin(this.business, recid);
    if (deleted && deleted === 'SUCCESS') {
      this.adminDeleteConfirmationArray[index] = false;
      this.business = await this._airportService.getBusiness(this.business.id.toString());
    } else {
      this._snackBar.open('Delete Admin Failed: ' + deleted, 'Close', {
        duration: 5000
      });
    }
  }

  async onDelete(deleteText: string, deleteReason: string) {
    if (deleteText.toLocaleLowerCase() !== 'delete'.toLocaleLowerCase()) {
      this._snackBar.open('You must type "Delete" to verify you want to delete this business', 'Close', {
        duration: 8000
      });
      return;
    }
    if (deleteReason.length < 1 || deleteReason.length > 1024) {
      this._snackBar.open('You must provide a reason the business is being deleted', 'Close', {
        duration: 8000
      });
      return;
    }
    if (deleteText.toLocaleLowerCase() === 'delete'.toLocaleLowerCase()) {
      const addedNote = await this._adminNotesService.createBusinessAdminNote(this.business.id, deleteReason);
      const deleted = await this._businessService.deleteBusiness(this.business);
      if (deleted) {
        this.dialogRef.close();
        if (this.business.airports.length > 0) {
          this.router.navigate(['/airports', this.business.airports[0].identifier]);
          window.location.reload(true);
        } else {
          this.router.navigate(['/search']);
        }
      } else {
        this._snackBar.open('Delete Failed', 'Close', {
          duration: 2000
        });
      }
    }
  }

  async pocCheckBoxChanged(event: MatCheckboxChange, recid: number, fboFeePoc: boolean) {
    const ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
    try {
      await this._businessService.updateBusinessAdmin(this.business, recid, event.source.checked, fboFeePoc);
    } catch (e) {
      this._snackBar.open(ERROR_MSG, 'Error', {
        duration: 6000
      });
      throw e;
    }
  }

  async feePocCheckBoxChanged(event: MatCheckboxChange, recid: number, primaryPoc: boolean) {
    const ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
    try {
      await this._businessService.updateBusinessAdmin(this.business, recid, primaryPoc, event.source.checked);
    } catch (e) {
      this._snackBar.open(ERROR_MSG, 'Error', {
        duration: 6000
      });
      throw e;
    }
  }

  async regionalBadgeSelected(event: MatSelectChange) {
    const ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
    const BUSINESS_ID = this.business.id;
    const allBusinessTags = await this._tagService.getAllTags();

    try {
      if (this.selectedRegionalBadgeId === '0') {
        // check if it has any regional tag already assigned to business, and if so delete it
        const previousTag = this.getRegionalTagAssignedToBusiness();
        if (previousTag != null && hasTag(this.business.tags, previousTag.tagName)) {
          const TAG_ID = previousTag.tagId;
          await this._tagService.deleteTag(TAG_ID, BUSINESS_ID);
          // remove from business tags to keep in sync
          const index = this.business.tags.map(t => t.tagId).indexOf(TAG_ID);
          if (index > -1) {
            this.business.tags.splice(index, 1);
          }
        }
      } else {
        const TAG_ID = this.selectedRegionalBadgeId;
        await this._tagService.postTag(TAG_ID, BUSINESS_ID);
        // add to business tags to keep in sync
        this.business.tags.push(allBusinessTags.find(t => t.tagId === TAG_ID));
      }

    } catch (e) {
      this._snackBar.open(ERROR_MSG, 'Error', {
        duration: 6000
      });
      throw e;
    }
  }

  dateRangeSelected (event: MatSelectChange) {
    this.selectedDateRange = event.value;
    this.activeFTEAwardTags = this.getActiveFTEAwardTags(this.selectedDateRange);
    this.NationalWinnerTag = this.activeFTEAwardTags.find(t => t.tagName.includes(' National'));
    this.DistinguishedSchoolTag = this.activeFTEAwardTags.find(t => t.tagName.includes('Distinguished Flight School'));
    this.activeRegionalTags = this.activeFTEAwardTags.filter(t => t.tagName.includes('Region'));

    const regionalAwardTag = this.getRegionalTagAssignedToBusiness();
    this.selectedRegionalBadgeId = regionalAwardTag != null ? regionalAwardTag.tagId : '';
  }

  getRegionalTagAssignedToBusiness() {
    const activeTagsAssignedToBusiness = this.business.tags.filter(bt => this.activeFTEAwardTags.find(t => t.tagId === bt.tagId));
    let regionalAwardTag: Tag;
    if (activeTagsAssignedToBusiness != null && activeTagsAssignedToBusiness.length > 0) {
      regionalAwardTag = activeTagsAssignedToBusiness.find(t => t.tagName.includes('Region'));
    }
    return regionalAwardTag;
  }

  getAwardTagDateRanges(): string[] {
    const toReturn = [];
    const datesToExclude = ['2012', '2013', '2014', '2015', '2016', '2017'];
    const re = /Awards::Flight Training::(?<dateRange>\d{4}-?\d{0,2}) /;
    const awardTags = this._tagService.searchTagsByName(this.allTags, 'Awards::Flight Training::');
    for (const awardTag of awardTags) {
      const match = awardTag.tagName.match(re);
      if (match != null && match[1] != null && !toReturn.includes(match[1]) && !datesToExclude.includes(match[1])) {
        toReturn.push(match[1]);
      }
    }
    return toReturn;
  }

  formatTagName(tagName: string): string {
    let formattedName = '';
    let re = /Awards::Flight Training::\d{4}-?\d{0,2}\D+- (?<regionName>\D+) Region/;
    let match = tagName.match(re);
    if (match != null && match[1] != null) {
      formattedName = match[1];
    } else {
      re = /Awards::Flight Training::\d{4}-?\d{0,2}\ Regional Best - (?<regionName>\D+)/;
      match = tagName.match(re);
      if (match != null && match[1] != null) {
        formattedName = match[1];
      }
    }
    return formattedName;
  }

  getActiveFTEAwardTags(range: string): Tag[] {
    let activeTags = this._tagService.searchTagsByName(this.allTags, 'Awards::Flight Training::' + range);
    // should never happen but if somehow does not find any matches, return empty array.
    if (activeTags.length === 0) {
      activeTags = [];
    }
    return activeTags;
  }
}

